<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui'

defineProps<{
  links: NavigationMenuItem[]
}>()
</script>

<template>
  <div class="fixed inset-y-0 left-8 z-10 items-center hidden lg:flex">
    <UNavigationMenu
      :items="links"
      variant="link"
      color="neutral"
      :collapsed="true"
      :tooltip="true"
      orientation="vertical"
      :ui="{
        root: 'flex flex-col items-center justify-center w-20 h-3/4 bg-slate-400/30 backdrop-blur-sm rounded-full shadow-lg shadow-neutral-900/5',
        link: 'py-7',
        linkLeadingIcon: 'size-7 text-wine-400 active:text-slate-100 hover:text-slate-100',
        separator: 'bg-wine-400 w-10/12'
      }"
    >
      <template #list-trailing>
        <div>
          <UIcon
            name="i-lucide-log-out"
            class="size-7 text-wine-400 cursor-pointer hover:text-slate-100"
            @click="console.log('logout')"
          />
        </div>
      </template>
    </UNavigationMenu>
  </div>
</template>
